import * as React from "react";
import { Navigate } from "react-router-dom";
import { SetupParsedLocation } from "./mobxStores/parsedLocation/setupParsedLocation";
import { selectIsLoggedIn } from "./store/userSlice";
import { useAppSelector } from "./store/hooks";

interface Props extends React.PropsWithChildren {}
export const PrivateRoute: React.FC<Props> = ({ children }) => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  if (!isLoggedIn) {
    return <Navigate to={"/signin"} />;
  }

  return (
    <>
      <SetupParsedLocation />
      {children}
    </>
  );
};
